import api from '../../api'

export const jobsToInvoiceCompareEndpoint = '/web/admin/jobs-to-invoice/compare'

export type JobsToInvoiceCompareFilters = {
  startDate: string | null
  endDate: string | null
  divisionGroups: string[] | null
  workAreaStatuses: number[] | null
}

export type JobsToInvoiceCompareRequest = {
  tenantId: number
  filters: JobsToInvoiceCompareFilters
}

export type FieldDifference = {
  field: string
  current: string
  facts: string
}

export type JobCandidateDifference = {
  jobId: number
  differences: FieldDifference[]
}

export type JobsToInvoiceComparison = {
  isIdentical: boolean
  currentJobCount: number
  factsJobCount: number
  missingFromFacts: number[]
  extraInFacts: number[]
  differences: JobCandidateDifference[]
}

export const compareJobsToInvoice = async (request: JobsToInvoiceCompareRequest): Promise<JobsToInvoiceComparison> => {
  return (await api.post(jobsToInvoiceCompareEndpoint, request)).data
}
